import styled from 'styled-components';

export const StylePlayersContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 50px;
    margin-bottom: 100px;
    padding: 0 10%;

    @media (max-width: 1300px) {
        padding: 0 5%;
    }
`

export const StyleTopBar = styled.div`
    display: flex;
    flex-direction: row; 
    align-items: center;
    
    h2 {
        color: white;
        margin-right: 50px;
        font-size: 36px;
    }

    span {
        color: white;
        margin-right: 10px;
    }

    & .date {
        display: flex;
        flex-direction: row;
    }

    @media (max-width: 650px) {
        flex-direction: column;
        align-items: start;

        h2 {
            color: white;
            margin-right: 50px;
            font-size: 24px;
        }
    }  
`

export const StyledSelect = styled.select`
    background-color: rgba(0, 0, 0, 0);
    border: none;
    outline: none;
    color: white;
    margin-left: 0.5rem;
    text-align: left;
    font-size: 14px;

    @media (max-width: 650px) {
        font-size: 12px;
    }

    &.super {
        color: #ff0000;
    }

    &.partner {
        color: #0500ee;
    }
`
export const StyledOption = styled.option`
    background-color: #416043;
    border: none;
    outline: none;
    color: white;
    font-size: 14px;

    @media (max-width: 650px) {
        font-size: 12px;
    }
`

export const StyledTableNameFilter = styled.div`
    display: flex;
    align-items: center;
    p {
        color:white;
        margin-right: 10px;
        font-size: 14px;
    }
`

export const StyleTransactionTable = styled.table`
    border: 1px solid #FFF; 
    border-radius: 1.5rem;
    border-spacing: 0;
    flex: 1;
    height: fit-content;
    & tr:last-child td {
        border: none;
    }

    thead {
        height: 50px;
        border-top: 1px solid #FFF;
        border-bottom: 1px solid #FFF;
    }

    tbody {
        height: 50px;
        border-top: 1px solid #FFF;
        border-bottom: 1px solid #FFF;
    }

    tr {
        height: 50px;
        border-top: 1px solid #FFF;
        border-bottom: 1px solid #FFF;
    }

    th {
        color: white;
        font-weight: 400;
        border-bottom: 1px solid white;
        font-size: 16px;

        @media (max-width: 768px) {
            font-size: 14px;
        }

        @media (max-width: 560px) {
            font-size: 12px;
        }
    }

    td {
        border: none;
        color: white;
        font-weight: 400;
        text-align: center;
        font-family: Prompt;
        font-size: 16px;
        border-bottom: 1px solid white;

        &.win {
            color:#0F0;
        }

        &.lose {
            color: #F00;
        }

        @media (max-width: 768px) {
            font-size: 14px;
        }

        @media (max-width: 560px) {
            font-size: 12px;
        }
    }
`

export const StylePagination = styled.div`
    display: flex;
    flex-direction: row;
    margin-top: 20px;
    margin-bottom: 100px;
    align-items: center;
    justify-content: end;

    span {
        color: white;
        margin: 0 10px;
    }

    button {
        cursor: pointer;
    }
`